var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorefront24Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.a,.b{stroke:#fafafc;stroke-width:4px;}.b{fill:#d4d5e8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 88,
    height: 88
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.363 11.015)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.054,24.627,71.2,8.581A7.212,7.212,0,0,0,64.185,3h-51A7.21,7.21,0,0,0,6.208,8.581L2.353,24.627A12.392,12.392,0,0,0,4.629,35.2a14.076,14.076,0,0,0,1.028,1.065V61.748A7.365,7.365,0,0,0,13,69.092h51.4a7.365,7.365,0,0,0,7.344-7.344V36.266a13.58,13.58,0,0,0,1.028-1.028A12.351,12.351,0,0,0,75.054,24.627ZM64.075,10.307l3.855,16.046a4.979,4.979,0,0,1-.918,4.3,4.308,4.308,0,0,1-3.451,1.726,4.59,4.59,0,0,1-4.443-4.186l-2.13-17.845Zm-21.7.037h7.2l1.983,16.6a4.936,4.936,0,0,1-1.212,3.929,4.379,4.379,0,0,1-3.488,1.505,4.671,4.671,0,0,1-4.48-4.81Zm-16.56,16.6,2.019-16.6h7.2V27.564a4.718,4.718,0,0,1-4.737,4.81,4.418,4.418,0,0,1-3.268-1.505A5.216,5.216,0,0,1,25.815,26.94ZM9.476,26.352l3.708-16.009h7.233l-2.13,17.845a4.617,4.617,0,0,1-4.443,4.186,4.226,4.226,0,0,1-3.415-1.726A4.855,4.855,0,0,1,9.476,26.352ZM13,61.748V39.607a6.647,6.647,0,0,0,.845.11,11.489,11.489,0,0,0,8.225-3.488,11.809,11.809,0,0,0,8.482,3.488A11.641,11.641,0,0,0,38.74,36.3a12.035,12.035,0,0,0,8.408,3.415,11.66,11.66,0,0,0,8.225-3.488A11.489,11.489,0,0,0,63.6,39.718a6.647,6.647,0,0,0,.845-.11V61.748Z",
    transform: "translate(-2.005 -3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorefront24Px);
export default __webpack_public_path__ + "static/media/storefront-24px.c996dee25bfbbd28afbaed76a5bfb4d2.svg";
export { ForwardRef as ReactComponent };